import React from 'react';
import { makeStyles } from '@mui/styles';
import { setTheme } from '../../hookState/ThemeState';
import { useHistory, generatePath } from 'react-router-dom';
import {
    Box,
    Card,
    CardContent,
    CardActionArea,
    Tooltip,
    Skeleton,
    Typography,
    CardMedia,
} from '@mui/material';

import Helper from '../../utility/helper';
import { DEFAULT_COLOR } from '../../constants/Constant';
import RouteConstants from '../../constants/routeConstants';
import DefaultEvent from '../../assets/images/default_event.jpg';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
const useStyles = makeStyles({
    multiLineEllipsis: {
        // overflow: 'hidden',
        // textOverflow: 'ellipsis',
        // display: '-webkit-box',
        // '-webkit-line-clamp': LINES_TO_SHOW,
        // '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
        // width: '250px',
    },
    cardImage: {
        // height: 100,
        width: '100%',
        // objectFit: 'contain',
    },
});

export const EventCard = (props) => {
    const color = props && props.eventList && JSON.parse(props.eventList.color);
    const classes = useStyles();
    const history = useHistory();
    const gUserInfo = Helper.getStorage('userInfo');


    const cardRedirect = async (eventData, event) => {
        event.preventDefault();
        event.stopPropagation();
        props.onCardClick()
        if (eventData) {

            if (eventData && !eventData.moduleDetails) {
                let moduleDetailResult = await ApiHelper.get(APIURLConstants.GET_EVENT_MODULE_DETAILS(eventData.eventID));
                if (moduleDetailResult) {
                    eventData.moduleDetails = moduleDetailResult.data;
                }
            }
            Helper.setStorage('eventInfo', eventData);
            // const checkAgent = gUserInfo.roles.find(
            //     (key) => key.eventRole === 'AGENT'
            // );
            let newEventData = [];
            ApiHelper.get(
                APIURLConstants.IS_AGENT(gUserInfo.userID, eventData.eventID)
            ).then((res) => {
                //newEventData.push(res.data)
                // commenting this for improving api performance
                //Helper.setStorage('eventModuleConfig', res.data);
                let path = '';
                setTheme(eventData);
                Helper.setStorage('agentInfo', gUserInfo);
                if (res.data.agent) {
                    path = generatePath(RouteConstants.EVENT_AGENT_PROFILE, {
                        eventID: eventData.eventID,
                    });
                } else {
                    path = generatePath(RouteConstants.EVENT_DETAIL, {
                        eventID: eventData.eventID,
                    });

                    // ApiHelper.get(
                    //     APIURLConstants.GET_AGENT_CONNECTIONS(
                    //         gUserInfo.userID,
                    //         eventData.eventID
                    //     )
                    // )
                    // .then((res) => {                    
                    //     if (res.data) {
                    //         let result = res.data.reduce(function (r, c) {
                    //             r[c.userID] = r[c.userID] || {
                    //                 userID: c.userID,
                    //                 userType: c.userType,
                    //                 firstName: c.firstName,
                    //                 lastName: c.lastName,
                    //                 email: c.email,
                    //                 picUrl: c.profilePicUrl,
                    //                 roles:  c.roles,
                    //                 isNotification: c.isNotification,
                    //                 appNotificationSetting: c.appNotificationSetting, 
                    //                 modules: [],
                    //                 userTags: c.userTags,
                    //             };
                    //             r[c.userID].modules.push({
                    //                 moduleName: c.moduleName,
                    //                 statusName: c.statusName,
                    //                 status: c.requestStatus,
                    //                 noAccess: c.noAccess,
                    //             });

                    //             return r;
                    //         }, {});

                    //         let data = Object.values(result).reduce(
                    //             (r, o) => {
                    //                 r[
                    //                     o.userID === gUserInfo.userID
                    //                         ? 'agentProfile'
                    //                         : 'agentConnections'
                    //                 ].push(o);
                    //                 return r;
                    //             },
                    //             { agentProfile: [], agentConnections: [] }
                    //         );  
                    //         if(data &&
                    //             data.agentConnections &&
                    //             data.agentConnections.length > 0){
                    //                 path = generatePath(RouteConstants.EVENT_AGENT_PROFILE, {
                    //                     eventID: eventData.eventID,
                    //                 });
                    //             }else{
                    //                 path = generatePath(RouteConstants.EVENT_DETAIL, {
                    //                     eventID: eventData.eventID,
                    //                 });
                    //             }
                    //             history.push({
                    //                 pathname: path,
                    //                 state: { event: newEventData[0] },
                    //             });
                    //     }
                    // })
                    // .catch((err) => {
                    //     //... Check if user's session has expired
                    //     if (err.response && err.response.status === 401) {
                    //         console.log(err);
                    //     }
                    // });
                    // setTheme(eventData);
                }
                history.push({
                    pathname: path,
                    state: { event: eventData },
                });
            });
        }
    };

    // const image_url =
    // 'https://bbopsstoragedev.blob.core.windows.net/letsgo-dev-images/allStar.png';
    return (
        <Card
            sx={{
                width: 240,
                height: 180,
                borderRadius: 4,
                boxShadow:
                    'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
                p: 0,
                m: '10px',
                // borderColor:
                //     props && props.eventList && props.eventList.secondary,
            }}
            onClick={(e) => cardRedirect(props && props.eventList, e)}>
            <CardActionArea>
                <CardContent>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                        <Box
                            sx={{
                                display: 'inline-block',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                height: '100px',
                                width: '100%',
                                overflow: 'hidden',
                                // p: '10px',
                            }}>
                            {props && props.loading && (
                                <Skeleton
                                    animation="wave"
                                    sx={{
                                        opacity: 0.5,
                                        backgroundColor: color
                                            ? color.primary
                                            : DEFAULT_COLOR.primary,
                                        height: '120px',
                                    }}
                                />
                            )}
                            <CardMedia
                                component="img"
                                className={classes.cardImage}
                                image={
                                    props &&
                                        props.eventList &&
                                        props.eventList.eventImageUrl != ''
                                        ? props.eventList.eventImageUrl
                                        : DefaultEvent
                                }
                                alt="event image"
                            />
                        </Box>
                        <Box
                            sx={{
                                display: 'inline-block',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                height: '80px',
                                backgroundColor: color
                                    ? color.primary
                                    : DEFAULT_COLOR.primary,
                                color: '#fff',
                                p: '10px',
                            }}>
                            <Tooltip
                                title={
                                    props &&
                                        props.eventList &&
                                        props.eventList.eventName
                                        ? props.eventList.eventName
                                        : ''
                                }
                                arrow>
                                <Typography
                                    variant="h6"
                                    className={classes.multiLineEllipsis}
                                    fontSize={16}
                                    lineHeight="18px"
                                    height={19}
                                    fontWeight={500}
                                    fontStyle="normal"
                                    gutterBottom>
                                    {props && props.loading && (
                                        <Skeleton
                                            animation="wave"
                                            sx={{
                                                bgcolor: '#fff3',
                                                height: '19px',
                                            }}
                                        />
                                    )}
                                    {props &&
                                        props.eventList &&
                                        props.eventList.eventName}
                                </Typography>
                            </Tooltip>
                            <Typography
                                variant="subtitle2"
                                component="div"
                                height={13}
                                lineHeight="12px"
                                fontSize={11}
                                fontWeight="normal"
                                fontStyle="normal"
                                gutterBottom>
                                {props && props.loading ? (
                                    <Skeleton
                                        animation="wave"
                                        sx={{
                                            bgcolor: '#fff3',
                                            height: '13px',
                                        }}
                                    />
                                ) : (
                                    Helper.FormatMonthWithDate(
                                        props &&
                                        props.eventList &&
                                        props.eventList.startDate
                                    ) +
                                    ' - ' +
                                    Helper.FormatMonthWithDate(
                                        props &&
                                        props.eventList &&
                                        props.eventList.endDate
                                    )
                                )}
                            </Typography>
                            <Tooltip
                                title={
                                    props &&
                                        props.eventList &&
                                        props.eventList.venue
                                        ? props.eventList.venue
                                        : ''
                                }
                                arrow>
                                <Typography
                                    gutterBottom
                                    className={classes.multiLineEllipsis}
                                    fontStyle="normal"
                                    fontWeight={500}
                                    variant="h6"
                                    color="#fff"
                                    fontSize={15}
                                    lineHeight="18px"
                                    height={18}
                                    component="div">
                                    {props && props.loading ? (
                                        <Skeleton
                                            animation="wave"
                                            sx={{
                                                bgcolor: '#fff3',
                                                height: '19px',
                                            }}
                                        />
                                    ) : (
                                        props &&
                                        props.eventList &&
                                        props.eventList.venue
                                    )}
                                </Typography>
                            </Tooltip>
                        </Box>
                    </Box>

                    {/* <Box
                        className={classes.container}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            color: '#fff',
                            height: '110px',
                            p: '10px',
                        }}>
                      
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: color && color.primary,
                            color: '#fff',
                            // height: '60px',
                            p: '10px',
                        }}>
                        <div className={classes.container}>
                            <Tooltip
                                title={
                                    props &&
                                    props.eventList &&
                                    props.eventList.eventName
                                        ? props.eventList.eventName
                                        : ''
                                }
                                arrow>
                                <Typography
                                    variant="h6"
                                    className={classes.multiLineEllipsis}
                                    fontSize={17}
                                    gutterBottom>
                                    {props && props.loading && (
                                        <Skeleton
                                            animation="wave"
                                            sx={{
                                                bgcolor: '#fff3',
                                                height: '43px',
                                            }}
                                        />
                                    )}{' '}
                                    {props &&
                                        props.eventList &&
                                        props.eventList.eventName}
                                </Typography>
                            </Tooltip>
                        </div>

                        <Typography variant="subtitle2" component="div">
                            {props && props.loading ? (
                                <Skeleton
                                    animation="wave"
                                    sx={{ bgcolor: '#fff3', height: '43px' }}
                                />
                            ) : (
                                Helper.FormatMonthWithDate(
                                    props &&
                                        props.eventList &&
                                        props.eventList.startDate
                                ) +
                                ' - ' +
                                Helper.FormatMonthWithDate(
                                    props &&
                                        props.eventList &&
                                        props.eventList.endDate
                                )
                            )}
                        </Typography>

                        <Typography
                            gutterBottom
                            variant="h6"
                            color="#fff"
                            fontSize={17}
                            component="div">
                            {props && props.loading ? (
                                <Skeleton
                                    animation="wave"
                                    sx={{ bgcolor: '#fff3', height: '43px' }}
                                />
                            ) : (
                                props &&
                                props.eventList &&
                                props.eventList.venue
                            )}
                        </Typography>
                    </Box> */}
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default EventCard;
